import { useEffect, useRef } from 'react';
import { useRealtime } from './RealtimeProvider';
import Swal from 'sweetalert2';

/**
 * Escuta eventos SSE do tipo "dossie".
 *
 * Quando action === 'concluido':
 *  - Exibe Swal com título, mensagem e botão "Baixar" (se houver URL).
 *  - Dispara CustomEvent 'dossie:concluido' no window para que a tela de
 *    gerenciamento de dossiês recarregue a lista imediatamente.
 */
export default function DossieRealtimeBridge() {
  const { on } = useRealtime();
  const shownRef = useRef(new Set());

  useEffect(() => {
    if (!on) return;

    const handleDossie = (event) => {
      if (!event || typeof event !== 'object') return;

      const action = String(event.action || '').toLowerCase();
      if (action !== 'concluido') return;

      // Dedupe por id do evento
      const evtId = event.id || event.payload?.log_id;
      if (evtId && shownRef.current.has(evtId)) return;
      if (evtId) shownRef.current.add(evtId);

      const title    = event.title   || event.payload?.title   || 'Dossiê pronto';
      const message  = event.message || event.payload?.message || '';
      const url      = event.payload?.url || null;
      const severity = String(event.severity || 'info').toLowerCase();

      const iconMap = { success: 'success', error: 'error', warning: 'warning', warn: 'warning' };
      const icon = iconMap[severity] || 'success';

      Swal.fire({
        icon,
        title,
        text: message || undefined,
        confirmButtonText: 'OK',
        confirmButtonColor: '#4099ff',
        showDenyButton: !!url,
        denyButtonText: 'Baixar',
        reverseButtons: true,
      }).then((result) => {
        if (result.isDenied && url) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      });

      // Notifica a tela de dossiês para recarregar a lista
      try {
        window.dispatchEvent(new CustomEvent('dossie:concluido', { detail: event }));
      } catch {}
    };

    const off = on('dossie', handleDossie);
    return () => off?.();
  }, [on]);

  return null;
}
